import MarksSlider from './MarksSlider';

const MarksFields = ({ formData, dispatch }) => (
  <>
    <h3 className="font-semibold mb-4">📊 Marks Selection</h3>
    <MarksSlider
      label="10th Marks"
      value={formData.tenthMarks}
      field="tenthMarks"
      dispatch={dispatch}
      marksType={formData.tenthMarksType || 'Percentage'}
      marksTypeField="tenthMarksType"
    />
    <MarksSlider
      label="12th Marks"
      value={formData.twelfthMarks}
      field="twelfthMarks"
      dispatch={dispatch}
      marksType={formData.twelfthMarksType || 'Percentage'}
      marksTypeField="twelfthMarksType"
    />
    <MarksSlider
      label="Graduation Marks"
      value={formData.percentage}
      field="percentage"
      dispatch={dispatch}
      marksType={formData.percentageType || 'Percentage'}
      marksTypeField="percentageType"
    />
  </>
);

export default MarksFields;

